// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import promise from 'es6-promise';
import 'babel-polyfill';
import apiUrl from './api/apiUrl.js'
import store from './store/index.js'
import toast from './utils/toast'
promise.polyfill();

router.beforeEach((to, from, next) => {
  if (to.name == 'Index' && from.name != null) {
    console.log(to)
    console.log(from)
    apiUrl.globalData.isAutoPlay = false;
    console.log(apiUrl.globalData);
  }
  next()
})


Vue.config.productionTip = true

Vue.config.devtools = true

Vue.use(VueAxios, axios)
Vue.use(toast)

router.beforeEach((to, from, next) => {
  next();
});

Vue.prototype.GLOBAL = {
  isAutoPlay: true
}

require('./api/mock');

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/home.js